export default "__VITE_ASSET__BLsbP2k0__"